import React, { useContext } from "react";
import { AccessControlContext } from "../contexts/AccessControlContext";
import { Col, Row } from "react-bootstrap";
import RefreshLoadingButton from "../shared/RefreshLoadingButton";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faFile } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import { ReportGenerationProps } from "./ReportGeneration";
import config from "../../config";

interface Props {
  resultDataFetching: boolean;
  customerId: number;
  resultSelected: boolean;
  showGenerateReport: boolean;
  onDataRefreshClick: () => void;
  onUploadButtonClick: () => void;
  onGenerateAppendixButtonClick: () => void;
  onGenerateReportButtonClick: () => void;
  isFlexibleSurvey?: boolean;
}

export function HeaderToolbar(props: Props) {
  const { t } = useTranslation();
  const accessControlContext = useContext(AccessControlContext);
  const userCanUploadResults = accessControlContext.canI("add", "results", props.customerId);
  const ReportGenerationButton: React.FC<ReportGenerationProps> = (props) => {
    if (!props.condition) {
      return null;
    }
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={props.onClick}
        startIcon={<FontAwesomeIcon style={{ cursor: "pointer" }} icon={props.icon} />}
      >
        {props.label}
      </Button>
    );
  };

  return (
    <Row>
      <Col>
        <>
          <Stack direction="row" spacing={2} alignItems="center">
            <ReportGenerationButton
              condition={!!userCanUploadResults}
              onClick={props.onUploadButtonClick}
              icon={faUpload}
              label={t("results.submitResult")}
            />
            <ReportGenerationButton
              condition={config.reportsEnabled && props.showGenerateReport && props.resultSelected}
              onClick={props.onGenerateReportButtonClick}
              icon={faFile}
              label={t("results.generateReport")}
            />
            <ReportGenerationButton
              condition={props.showGenerateReport && props.resultSelected}
              onClick={props.onGenerateAppendixButtonClick}
              icon={faFile}
              label={t("results.generateAppendix")}
            />
          </Stack>
        </>
      </Col>
      <Col className="d-flex justify-content-end">
        <RefreshLoadingButton isLoading={props.resultDataFetching} onClick={props.onDataRefreshClick} />
      </Col>
    </Row>
  );
}
